import { all, call, put, takeLatest } from "redux-saga/effects";
import { JOB_TIME_ENTRY_REPORT_REQUEST } from "./actionType";
import {
  getJobTimeEntryReportSuccess,
  getJobTimeEntryReportFail,
} from "./action";
import { jobTimeEntryReportAPI } from "../../helpers/fakebackend_helper";

function* getJobTimeEntryReportSaga({ payload }) {
  try {
    const response = yield call(jobTimeEntryReportAPI, payload);
    yield put(getJobTimeEntryReportSuccess(response));
  } catch (error) {
    yield put(getJobTimeEntryReportFail(error));
  }
}

export function* watchGetJobTimeEntryReportSaga() {
  yield takeLatest(JOB_TIME_ENTRY_REPORT_REQUEST, getJobTimeEntryReportSaga);
}

export default function* JobTimeEntryReportSaga() {
  yield all([watchGetJobTimeEntryReportSaga()]);
}
